import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "@react/shared/ui/Button"

// Page title + Export / Nouvel ouvrage actions.
const Header = ({ onNewClick, onExport }) => (
  <div className="flex items-start justify-between gap-6 mb-6">
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">
        {I18n.t("quotes.qline_service_blueprints.index.title")}
        <span className="text-slate-400 font-normal ml-2">
          {I18n.t("quotes.qline_service_blueprints.index.subtitle")}
        </span>
      </h1>
      <p className="text-sm text-slate-500 mt-1">
        {I18n.t("quotes.qline_service_blueprints.index.description")}
      </p>
    </div>

    <div className="flex items-center gap-2">
      <Button variant="secondary" onClick={onExport}>
        <FontAwesomeIcon icon="file-export" className="text-slate-500" />
        {I18n.t("quotes.qline_service_blueprints.index.export")}
      </Button>

      <Button variant="primary" onClick={onNewClick}>
        <FontAwesomeIcon icon="plus" />
        {I18n.t("quotes.qline_service_blueprints.index.new_service")}
      </Button>
    </div>
  </div>
)

export default Header
